<app-session-handoff-page
  pageTitle="You're almost ready for your notary session"
  cardMessage="Please confirm the participants below who will be joining the notary session from this device."
  (participantJoined)="onParticipantJoined($event)"
>
</app-session-handoff-page>

<div class="welcome-page-v2__footer">
  <app-button [isDisabled]="!hasAssociatedUsers()" (buttonClick)="onContinue()" type="primary">
    {{ continueButtonText() }}
  </app-button>
</div>
